import React, {
  useCallback, useEffect, useState,
} from 'react';

import { useAppSelector } from '~/store';

// TODO: Нужно не на каждую ссылку обработчик вешать, а слушать событие изменения роута и
// превентить его, если есть не сохраненные изменения

export const useAddHandlersOnChangeContent = (isChangeContent: boolean) => {
  const [links, setLinks] = useState<NodeListOf<HTMLAnchorElement> | []>([]);
  const { isOpenLibrary } = useAppSelector((state) => state.header);

  useEffect(() => {
    setLinks(document.querySelectorAll('a'));
  }, []);

  const linkClickhandler = useCallback(function (this: HTMLAnchorElement, e: MouseEvent) {
    const link = this;
    if (link.getAttribute('target') === '_blank') {
      return;
    }

    const warningModal = async () => {
      const { Modal } = await import('antd');

      Modal.warning({
        title: 'Внимание!',
        content: (
          <>
            Ваши изменения не сохранены, вы действительно хотите покинуть страницу?
          </>
        ),
        okText: 'Да',
        cancelText: 'Нет',
        okCancel: true,
        onOk: () => {
          links.forEach((link) => {
            link.removeEventListener('click', linkClickhandler);
          });
          link.click();
        },
        maskClosable: true,
      });
    };

    warningModal();
    e.preventDefault();
  }, [links]);

  useEffect(() => {
    if (isChangeContent) {
      links.forEach((link) => {
        link.addEventListener('click', linkClickhandler);
      });

      return () => {
        links.forEach((link) => {
          link.removeEventListener('click', linkClickhandler);
        });
      };
    }
    links.forEach((link) => {
      link.removeEventListener('click', linkClickhandler);
    });
  }, [links, isChangeContent]);

  useEffect(() => {
    return () => {
      links.forEach((link) => {
        link.removeEventListener('click', linkClickhandler);
      });
    };
  }, [links]);

  useEffect(() => {
    if (isOpenLibrary) {
      setTimeout(() => {
        setLinks(document.querySelectorAll('a'));
      });
    }
  }, [isOpenLibrary]);
};
